import "./footer.css"

export default function Footer () {

    return (
        <span className="Footer">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSc3T-DaJYBPqS_aYls3Ol5I_yLzPPI3tP8S8r6dOIw2vhFE5w/viewform?usp=sf_link"
                target="_blank"
                rel="noopener noreferrer"
                title="Заявка на вступление в Ассоциацию по развитию методов реабилитации лиц с ОВЗ"
            >
                <button className="footer-button">Присоединиться</button>
            </a>

            <span className="footer-right-side">
                <a className="contact-info" href="tel:+79009009090"> +7 927 320 80 20</a>
                <p className="contact-info">ardashova@inbox.ru</p>
                <p className="contact-info">Работаем с 9.00 до 18.00</p>
            </span>
        </span>
    )
}